import { Box, Chip, Typography } from "@mui/material";
import { memo } from "react";
import StepProgressList from "src/reusable/components/StepProgressList";
import { SideBarScroll } from "src/views/assistant/components/ui/SideBarScroll";
import type { ItemEquivalencyRecord } from "../services/ItemEquivalencyService";
import { VERDICT_COLORS, VERDICT_LABELS } from "../verdict";

const ItemEquivalencyPlanTab = memo(
  ({ record }: { record: ItemEquivalencyRecord }) => {
    // Stage status is computed on the server from what the record holds;
    // this tab only renders it.
    const items = record.stages.map((stage, index) => ({
      key: stage.key,
      label: `${index + 1}. ${stage.key.replaceAll("_", " ")}`,
      detail: stage.label,
      status: stage.status,
    }));

    return (
      <SideBarScroll>
        <Box sx={{ px: 1.5, pt: 1 }}>
          <Typography variant="subtitle2" fontWeight={600} noWrap>
            {record.title}
          </Typography>
          <StepProgressList
            items={items}
            unit="stages"
            showStatusChip
            headerAside={
              record.comparison_row_count > 0 && (
                <Chip
                  size="small"
                  label={
                    VERDICT_LABELS[record.computed_verdict] ??
                    record.computed_verdict
                  }
                  color={VERDICT_COLORS[record.computed_verdict] ?? "default"}
                  variant="outlined"
                  data-testid="peq-plan-verdict"
                />
              )
            }
          />
          {record.open_items.length > 0 && (
            <Box
              sx={{ mt: 2, p: 1.25, borderRadius: 1, bgcolor: "action.hover" }}
            >
              <Typography variant="caption" fontWeight={600}>
                {record.open_items.length} open evidence item
                {record.open_items.length === 1 ? "" : "s"}
              </Typography>
            </Box>
          )}
          {(record.documented_row_count ?? 0) > 0 && (
            <Chip
              size="small"
              variant="outlined"
              sx={{ mt: 2 }}
              label={`${record.documented_row_count} dedication consideration${
                record.documented_row_count === 1 ? "" : "s"
              }`}
              data-testid="peq-plan-documented-rows"
            />
          )}
        </Box>
      </SideBarScroll>
    );
  },
);

ItemEquivalencyPlanTab.displayName = "ItemEquivalencyPlanTab";

export default ItemEquivalencyPlanTab;
